<template>
  <div
    id="root"
    :style="{
      backgroundColor: switchBg ? bg : 'inherit'
    }"
    :class="{
      bgTransition: switchBg
    }"
  >
    <template v-if="isScreenHorizontal">
      <div class="horizontal-hint-container">
        <div class="bg">
          <animated-gradient-bg sign="horizontalBg"></animated-gradient-bg>
        </div>
        <div class="logo"></div>
        <p class="hint">为了您更好的浏览体验，请将手机竖起。</p>
      </div>
    </template>
    <page-header></page-header>
    <div class="page-main-body">
      <router-view />
    </div>
    <page-footer v-if="$route.meta.hasFooter"></page-footer>
    <page-menu></page-menu>
    <div
      class="page-transition-container"
      :class="[beforeEnterText !== null ? 'is-enter' : 'is-leave']"
      @transitionend="test"
    >
      <div class="page-transition__title">{{ beforeEnterText }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import eventBus from '@/utils/events';
import pageHeader from './pages/common/header.vue';
import pageFooter from './pages/common/footer.vue';
import pageMenu from './pages/common/menu.vue';
import animatedGradientBg from './pages/about/_animated-gradient-bg.vue';

export default {
  name: 'app-main-container',
  components: {
    pageHeader,
    pageMenu,
    pageFooter,
    animatedGradientBg,
  },
  data() {
    return {
      switchBg: false,
      bg: '',
      screenWidth: window.innerWidth,
      designWidth: 1920,
      isScreenHorizontal: false,
    };
  },
  computed: {
    ...mapState(['beforeEnterText']),
    rate() {
      return this.screenWidth / this.designWidth;
    },
  },
  watch: {
    $route() {
      this.init();
    },
    isScreenHorizontal(val) {
      if (!val) {
        this.pageInit();
      }
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      if (that.$bowser.mobile) {
        // 解决移动端 :active,:hover 无效
        document.body.addEventListener('touchstart', () => {});
        that.isHorizontal();
      }
    });
    that.$root.$on('bgChanged', (color) => {
      that.switchBg = true;
      that.bg = color;
    });
    that.$root.$on('resize', (obj) => {
      this.rePainImg(obj);
    });
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    ...mapMutations(['CLOSE_MENU', 'SIGN_ENTERED']),
    init() {
      const that = this;
      // that.CLOSE_MENU();
      that.switchBg = false;
      that.$nextTick(() => {
        that.pageInit();
        // 手机端处理
      });
    },
    test(e) {
      const isLeave = e.currentTarget.classList.contains('is-leave');
      if (isLeave) {
        eventBus.$emit('test', this.$store.state.beforeEnterText);
      }
    },
    onResize() {
      this.screenWidth = window.innerWidth;
      if (!this.$bowser.mobile) {
        this.rePainImg();
      } else {
        //
        this.isHorizontal();
      }
    },
    rePainImg(obj) {
      if (!this.$bowser.mobile) {
        const { rate } = this;
        let iterator;
        if (obj) {
          iterator = [obj][Symbol.iterator]();
        } else {
          const repainObjs = document.querySelectorAll('.repain');
          iterator = repainObjs[Symbol.iterator]();
        }
        let next = iterator.next();
        while (!next.done) {
          const img = next.value;
          if (img.dataset.naturalWidth) {
            img.style.cssText = `width:${Math.floor(img.dataset.naturalWidth * rate)}px`;
          }
          next = iterator.next();
        }
      }
    },
    isHorizontal() {
      const { orientation } = window;
      this.isScreenHorizontal = orientation === 90 || orientation === -90;
    },
  },
};
</script>

<style></style>
